import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const IframeCalculator = styled('iframe')({
  border: 'none',
  height: '100%',
  width: '100%',
});
